/**
 * HUB-C — Filtres statut SumUp (DS Remobiles).
 */
import React from 'react';
import { SUMUP_STATUS_FILTERS } from '../../utils/paiements/paiementsDisplay';

export default function ActivitePaiementsStatusFilters({ value, onChange, testIdPrefix = 'activite-paiements' }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid={`${testIdPrefix}-status-filters`}>
      {SUMUP_STATUS_FILTERS.map((f) => {
        const isActive = value === f.key;
        return (
          <button
            key={f.key}
            type="button"
            onClick={() => onChange(f.key)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold border transition-all ${
              isActive ? 'text-[var(--rm-white)]' : 'text-[var(--rm-gray-400)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`${testIdPrefix}-filter-${f.key}`}
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
